import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="read-more"
export default class extends Controller {
  static targets = ["text", "moreButton"];

  declare textTarget: HTMLElement;
  declare moreButtonTarget: HTMLElement;

  connect() {
    this.initializeText();

    // モーダル対応. モーダル表示するまで高さを計算できない場合がるため
    document.addEventListener("shown.bs.modal", () => {
      this.initializeText();
    });
  }

  initializeText() {
    const descriptionHeight = this.textTarget.offsetHeight;

    // 160px以上の高さの場合、コントローラー要素にis_accordionクラスを追加
    if (descriptionHeight >= 160) {
      this.element.classList.add("is_accordion");
    }
  }

  // 「もっと見る」「閉じる」ボタンのクリックイベントハンドラー
  toggleDescription() {
    // 実際のコンテンツの高さを取得（スクロール高さ）
    const fullHeight = this.textTarget.scrollHeight;

    // is_activeクラスの切り替え
    this.element.classList.toggle("is_active");

    // ボタンの状態に応じてテキストと高さを変更
    if (this.moreButtonTarget.classList.contains("is_open")) {
      // 閉じる状態に戻す
      this.moreButtonTarget.classList.remove("is_open");
      this.moreButtonTarget.textContent = "もっと見る";
      this.textTarget.style.maxHeight = "";
    } else {
      // 開く状態にする
      this.moreButtonTarget.classList.add("is_open");
      this.moreButtonTarget.textContent = "閉じる";
      this.textTarget.style.maxHeight = `${fullHeight}px`;
    }
  }
}
